import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { linkContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const BalacefAccountLink = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress1 = Environment.link;
  const contract = linkContract(tokenAddress1, web3);
  const balacefAccountLink = useCallback(
    async () => {
      try {
        const buy = await contract.methods.balanceOf(account).call();
        return buy/10**18;
      } catch (error) {
        throw error;
      }
    },
    [contract, account]
  );
  return { balacefAccountLink:balacefAccountLink };
};
export default BalacefAccountLink;